import styled, { css } from 'styled-components';
import { Title } from '../style';

const imgHeight = 408;

export const Body = styled.div.withConfig({
  shouldForwardProp: (prop) => !['hasImg'].includes(prop),
})`
  position: relative;
  display: grid;
  grid-template-columns: 45% 1fr;
  gap: 40px;
  min-height: calc(${imgHeight}px - 40px);
  padding: 0 48px;
  max-width: 1440px;
  margin: auto;

  ${({ hasImg }) =>
    hasImg
      ? css`
          &.square_image {
            gap: 115px;
            grid-template-columns: 1fr 265px;

            @media ${(props) => props.theme.device.tablet} {
              grid-template-columns: 1fr;
              gap: 20px;
              padding: 0;
            }
          }
        `
      : css`
          display: block;
        `}

  @media ${(props) => props.theme.device.tablet} {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0;

    .description {
      padding: 0 16px;
    }
  }
`;

export const ArticleTitle = styled(Title)`
  @media ${(props) => props.theme.device.tablet} {
    max-width: 96%;
    padding: 0 16px;
  }
`;

export const Image = styled.img`
  position: absolute;
  right: 0;
  z-index: 1;
  width: 48%;
  max-width: 686px;
  height: auto;
  max-height: ${imgHeight}px;
  box-shadow: 4px 6px 60px rgba(4, 86, 179, 0.1);
  object-fit: cover;

  @media ${(props) => props.theme.device.tablet} {
    position: static;
    width: var(--full-width);
    max-width: unset;
    margin-bottom: 16px;
  }

  &.square_image {
    background: ${(props) => props.theme.colors.white};
    box-shadow: none;
    max-width: 265px;
    max-height: 265px;
    right: 48px;

    @media ${(props) => props.theme.device.tablet} {
      margin: 0 auto 16px;
      display: block;
    }
  }
`;

export const CTAWrapper = styled.div`
  margin: 25px 0 18px;

  @media ${(props) => props.theme.device.tablet} {
    width: 100%;
    padding-inline: 16px;

    button {
      width: 100%;
    }
  }
`;
